import { z } from "zod";
import { optionalUuid } from "./_helpers/optional";
import { ExternalIdEntrySchema } from "./external-id.schema";

export const CrewSchema = z.object({
  id: z.string().uuid().describe("ID"),
  account_id: z.string().uuid().describe("Account"),
  business_id: z.string().uuid().describe("Business"),
  name: z.string().nullable().describe("Name"),
  primary_contact_id: z.string().uuid().nullable().describe("Primary Contact"),
  // ADR-0052: null = internal employee crew; set = subcontractor crew owned by
  // that trade-partner contact_role (subcontractor sub-role).
  trade_partner_contact_role_id: z
    .string()
    .uuid()
    .nullable()
    .describe("Trade Partner"),
  status: z.string().nullable().describe("Status"),
  notes: z.string().nullable().describe("Notes"),
  territory_id: z.string().uuid().nullable().describe("Territory"),
  started_on: z.string().nullable().describe("Started On"),
  home_base_location: z.string().nullable().describe("Home Base Location"),
  worker_count: z.number().int().nullable().describe("Worker Count"),
  capabilities: z.record(z.unknown()).nullable().describe("Capabilities"),
  custom_fields: z
    .record(z.unknown())
    .nullable()
    .optional()
    .describe("Custom Fields"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
  external_ids: ExternalIdEntrySchema.array()
    .optional()
    .describe("External IDs"),
});
export type Crew = z.infer<typeof CrewSchema>;

export const CrewInsertSchema = z.object({
  name: z.string().describe("Name"),
  primary_contact_id: optionalUuid().describe("Primary Contact"),
  trade_partner_contact_role_id: optionalUuid().describe("Trade Partner"),
  status: z.string().optional().describe("Status"),
  notes: z.string().optional().describe("Notes"),
  territory_id: optionalUuid().describe("Territory"),
  started_on: z.string().optional().describe("Started On"),
  home_base_location: z.string().optional().describe("Home Base Location"),
  worker_count: z.number().int().optional().describe("Worker Count"),
  capabilities: z.any().optional().describe("Capabilities"),
  custom_fields: z.any().optional().describe("Custom Fields"),
});

export const CrewUpdateSchema = CrewInsertSchema.partial();

export const CrewStatsSchema = z.object({
  crew_id: z.string().uuid().describe("Crew"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  started_on: z.string().nullable().describe("Started On"),
  years_experience: z.number().int().nullable().describe("Years Experience"),
  lifetime_sqft_installed: z.number().describe("Lifetime Sqft Installed"),
});
export type CrewStats = z.infer<typeof CrewStatsSchema>;

export const CrewListItemSchema = z.object({
  id: z.string().uuid().describe("ID"),
  name: z.string().nullable().describe("Name"),
  status: z.string().nullable().describe("Status"),
  worker_count: z.number().int().nullable().describe("Worker Count"),
  started_on: z.string().nullable().describe("Started On"),
  home_base_location: z.string().nullable().describe("Home Base Location"),
  leader_first_name: z.string().nullable().describe("Leader First Name"),
  leader_last_name: z.string().nullable().describe("Leader Last Name"),
  member_count: z.number().int().describe("Member Count"),
  external_ids: ExternalIdEntrySchema.array()
    .optional()
    .describe("External IDs"),
});
export type CrewListItem = z.infer<typeof CrewListItemSchema>;
